import { prop } from 'datx';

import { BaseModel } from './BaseModel';

interface IBackgrounds {
  [key: string]: Record<string, string>;
}

interface IAvatar {
  [key: string]: Record<any, any>;
}

export class Page extends BaseModel {
  public static type = 'page';

  @prop
  public avatars!: IAvatar;

  @prop
  public backgrounds!: IBackgrounds;
}
